import subModuleData from '../components/TabsForSubModule/subModuleData';
import getQueryParams from './getQueryParams';
/**
 * gotoManagement
 *  跳转至应用的管理页面
 *  @param {string} dataType - 跳转应用的dataType，默认为当前页面的dataType，当跳转至其他模块时，需手动传入目标模块的dataType （eg. task-management）
 *  @param {object} appInfo - 应用相关信息，默认为当前应用的信息，当跳转至其他模块的应用时，需传入目标应用的应用信息，
 *  包括 moduleId, appId, instanceConfig, name, moduleControlType等
 *  （eg. {moduleId: 13000, appId: 144332, name: '任务管理', instanceConfig: '', moduleControlType: 'org_control'}）
 *  @param {string} subRoute - 跳转的子路由，不传则跳转至管理页面的首页（eg. /workflow）
 * 	@param {Boolean} withAppId - 是否拼接appId
 * 	@param {Boolean} open - 是否打开新窗口
 **/
const gotoManagement = (dataType, appInfo, subRoute = '', withAppId = false, open = false, isManagement = false) => {
	// 是否是左邻环境
	const inZuolin = window.envType === 'zuolin';
	// 是否是wepark环境
	const inWePark = window.envType === 'wepark';
	// 当前的微前端名称
	const ehMicroName = window.ehMicroName || '';
	const pathname = window.location.hash.substring(1).split(/[?#&]/)[0];
	// 判断页面路径中是否包含微前端前缀，如果包含，相关的处理有区别
	const pathnameHasMicroName = pathname.includes(`/${ehMicroName}/`);

	let subModulePath;

	if (!dataType) {
		[dataType, subModulePath] = pathnameHasMicroName ? pathname.split('/').slice(2) : pathname.split('/').slice(1);
	}
	if (!appInfo || Object.prototype.toString.call(appInfo) !== '[object Object]' || !Reflect.ownKeys(appInfo).length) {
		const { moduleId, appId, instanceConfig, name, moduleControlType } = window.$$context;
		appInfo = { moduleId, appId, instanceConfig, name, moduleControlType };
	}

	if (subRoute && subRoute.substring(0, 1) !== '/') subRoute = `/${subRoute}`;

	let url = window.location.origin + window.location.pathname;
	url += pathnameHasMicroName ? `#/${ehMicroName}` : '#';
	if (inZuolin && subModuleData[dataType] && subModuleData[dataType].some(it => it.path === subModulePath)) {
		url += `/${dataType}/${subModulePath}/management${subRoute}`;
	} else {
		url += `/${dataType}${isManagement ? '' : '/management'}${subRoute}`;
	}
	if (inWePark || withAppId) {
		// 优化仅在wepark环境下需要添加appId
		const { appId } = getQueryParams();
		// 判断链接上是否有 ?
		const hasQuestionMark = subRoute.indexOf('?') > -1;
		// 判断链接上是否有 appId, 有则无需再拼接
		const hasAppId = /appId=\d+/.test(subRoute);
		const queryAppId = hasAppId ? '' : `${hasQuestionMark ? '&' : '?'}appId=${appId}`;
		url += queryAppId;
	}
	if (open) {
		window.open(url);
	} else {
		window.location.href = url;
	}
};

export default gotoManagement;
